import { createFileRoute } from "@tanstack/react-router";

import TodosStandard from "@/features/todos/todos-standard";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/ausgang/standard",
)({
  component: ReceivableStandardPage,
  staticData: {
    breadcrumb: ["todos.receivable.title"],
  },
});

function ReceivableStandardPage() {
  return <TodosStandard type="receivable" />;
}
